import { colors } from '../../../constants';

const styles = theme => ({
  wrapper: {
    width: '100%',
  },
  inputWrapper: {
    flex: 1,
  },
  button: {
    margin: theme.spacing.unit,
    backgroundColor: colors.parimary,
  },
  textEdit: {
    color: '#ffffff',
    marginRight: '4px',
  },
  field: {
    marginBottom: theme.spacing.unit * 2,
  },
});

export default styles;
